<template>
   <div>
      <v-container>
         <v-dialog
            v-model="eventmodal"
            persistent
            width="500px"
            height="500px"
            @keydown.esc="cancelBtnClick"
         >
            <v-sheet height="330px">
               <v-row no-gutters>
                  <v-col cols="12">
                     <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                        <v-toolbar-title>
                           <template v-if="$vuetify.breakpoint.mdAndUp">
                              {{ formtitle }}
                           </template>
                           <template v-else>
                              {{ shorttitle }}
                           </template>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2">Cancel</v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2">OK</v-btn>
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-row no-gutters>
                  <v-col cols="8">
                     <v-card flat class="pt-5 px-3">
                        <v-select
                           class="px-3"
                           label="Day"
                           :items="eventdayselect"
                           item-text="day"
                           item-value="dow"
                           return-object
                           v-model="edit_event_day"
                        >
                        </v-select>
                     </v-card>
                  </v-col>
               </v-row>
               <v-row no-gutters>
                  <v-card flat class="px-3">
                     <v-col sm="12">
                        <label for="start">Start Time</label>
                        <vue-timepicker
                           close-on-complete
                           class="ml-3 pt-1"
                           name="start"
                           :minute-interval="$globalstore.minute_interval"
                           v-model="edit_event_starttime"
                           drop-direction="up"
                           manual-input
                           auto-scroll
                        ></vue-timepicker>
                     </v-col>
                  </v-card>
               </v-row>
               <v-row no-gutters>
                  <v-card flat class="px-3">
                     <v-col sm="12">
                        <label for="end">End Time</label>
                        <vue-timepicker
                           close-on-complete
                           v-model="edit_event_endtime"
                           class="ml-5 pt-0"
                           name="end"
                           :minute-interval="$globalstore.minute_interval"
                           drop-direction="up"
                           manual-input
                           auto-scroll
                        ></vue-timepicker>
                     </v-col>
                  </v-card>
               </v-row>
               <v-row no-gutters>
                  <v-col>
                     <v-card flat class="px-6 pt-2">
                        <v-autocomplete
                           dense
                           v-model="edit_event_location"
                           :items="edit_locationdata"
                           label="Location"
                           item-text="location_name"
                           return-object
                        >
                        </v-autocomplete>
                     </v-card>
                  </v-col>
               </v-row>
            </v-sheet>
         </v-dialog>
      </v-container>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </div>
</template>

<script>
   import {GroupConst} from "@/common/constant.js";
   import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         VueTimepicker,
         ConfirmDlg,
      },
      data() {
         return {
            formtitle: "",
            shorttitle: "",
            edit_event_day: null,
            edit_event_starttime: "",
            edit_event_endtime: "",
            edit_event_location: null,
            edit_locationdata: [],
            eventdayselect: GroupConst.eventdayselect,
            resolve: null,
            reject: null,
            eventmodal: false,
            formmode: "add",
            previous_uniqueid: "",
            event_id: "",
         };
      },
      methods: {
         open() {
            this.formmode = "add";
            this.formtitle = "Add Event Master";
            this.shorttitle = "Add";
            this.eventmodal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         edit(eventobj) {
            if (eventobj) {
               this.formmode = "edit";
               this.formtitle = "Edit Event Master";
               this.shorttitle = "Edit";
               // Only available in edit mode
               this.event_id = eventobj.id;
               this.previous_uniqueid = eventobj.unique_id;
               this.edit_event_day = this.eventdayselect.find((x) => x.dow === eventobj.dow);
               this.edit_event_starttime = eventobj.start;
               this.edit_event_endtime = eventobj.end;
               this.edit_event_location = this.edit_locationdata.find(
                  (x) => x.location_id == eventobj.location_id
               );
               this.eventmodal = true;
               return new Promise((resolve, reject) => {
                  this.resolve = resolve;
                  this.reject = reject;
               });
            }
         },

         OkBtnClick() {
            if (
               this.edit_event_day &&
               this.edit_event_starttime &&
               this.edit_event_endtime &&
               this.edit_event_location
            ) {
               if (this.edit_event_endtime <= this.edit_event_starttime) {
                  this.ShowMessage({
                     title: "Error",
                     message: "End time must be greater than start time.",
                     color: "red",
                  });
                  return;
               } else {
                  let unique_id =
                     this.edit_event_day.dow + this.edit_event_starttime + this.edit_event_endtime;

                  let event = {
                     unique_id: unique_id,
                     dow: this.edit_event_day.dow,
                     daytext: this.edit_event_day.day,
                     start: this.edit_event_starttime,
                     end: this.edit_event_endtime,
                     location_id: this.edit_event_location.location_id,
                     location_name: this.edit_event_location.location_name,
                     id: this.formmode == "edit" ? this.event_id : "",
                  };
                  let payload = {
                     event: event,
                     mode: this.formmode,
                     previd: this.previous_uniqueid,
                  };
                  this.resolve(true);
                  this.eventmodal = false;
                  this.$emit("input", payload);
               }
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the event form.",
                  color: "red",
               });
               return;
            }
         },
         cancelBtnClick() {
            this.resolve(false);
            this.eventmodal = false;
         },

         async LoadLocationList() {
            await this.$http({
               url: "/cca/locationlist.php",
               method: "POST",
            }).then((response) => {
               const data = response.data;
               if (!data.error) {
                  this.edit_locationdata = data.locationlist;
               } else {
                  this.edit_locationdata = [];
               }
            });
         },
      },
      mounted() {
         this.LoadLocationList();
      },
   };
</script>
